'use client';
import React from 'react';
import Link from 'next/link';
import { LayoutDashboard, FileText, Settings } from 'lucide-react';

const mobileNavItems = [
  { id: 'mob-dashboard', label: 'Inbox', href: '/decision-dashboard', icon: <LayoutDashboard size={22} />, badge: 3 },
  { id: 'mob-quote', label: 'Quote', href: '/quick-quote-form', icon: <FileText size={22} /> },
  { id: 'mob-settings', label: 'Settings', href: '/business-settings', icon: <Settings size={22} /> },
];

export default function MobileBottomNav({ currentPath }: { currentPath: string }) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-[#0D0D0D] border-t border-[#1A1A1A] z-50 safe-area-inset-bottom">
      <div className="flex items-center justify-around px-2 py-2">
        {mobileNavItems.map((item) => {
          const isActive = currentPath === item.href;
          return (
            <Link
              key={item.id}
              href={item.href}
              className={`relative flex flex-col items-center gap-1 px-4 py-1.5 rounded-lg transition-all duration-150 min-w-[64px]
                ${isActive ? 'text-blue-400' : 'text-[#555] hover:text-[#999]'}
              `}
            >
              {item.icon}
              <span className="text-[10px] font-500">{item.label}</span>
              {item.badge && (
                <span className="absolute top-0 right-3 bg-amber-500 text-black text-[9px] font-700 rounded-full w-4 h-4 flex items-center justify-center">
                  {item.badge}
                </span>
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}